import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class ProdutosVendidosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaOrdem, buscaDataIni, buscaDataFim, buscaPessoa, buscaUsuario, buscaMunicipio,
            buscaGrupoProduto, buscaProduto } = this.props.filtros;

        if ((buscaDataIni) && (buscaDataFim)) {

            let dataIni = '';
            if ((buscaDataIni) && (buscaDataIni !== undefined)) {
                dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }
            let dataFim = '';
            if ((buscaDataFim) && (buscaDataFim !== undefined)) {
                dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }

            axios
                .get('/vendas/listaProdutosVendidos', {
                    params: {
                        print: true,
                        campoOrdem: buscaOrdem.campo,
                        tipoOrdem: buscaOrdem.ordem,
                        pessoa: buscaPessoa.key,
                        cidade: buscaMunicipio.key,
                        vendedor: buscaUsuario.key,
                        grupo: buscaGrupoProduto.key,
                        produto: buscaProduto.key,
                        dataIni,
                        dataFim,
                    }
                })
                .then(response => {
                    const { data } = response;
                    this.setState({
                        listaRegistros: data.dados,
                        carregando: false,
                    });
                })
                .catch(erro => {
                    console.warn(erro);
                    this.setState({
                        carregando: false,
                    });
                });
        } else {
            this.setState({
                listaRegistros: [],
                carregando: false,
            });
        }

    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }


    renderValor = (vlr) => {
        return (
            <span> {numeral(vlr).format('0,000.00')} </span>
        );
    };


    renderValorUN1 = (vlr, registro) => {
        return (
            <span> {numeral(registro.vlrItens / registro.qtdeItens).format('0,000.00')} </span>
        );
    };


    renderValorUN2 = (vlr, registro) => {
        return (
            <span> {registro.qtdeItens2 ? numeral(registro.vlrItens / registro.qtdeItens2).format('0,000.00') : ''} </span>
        );
    };

    renderPercVendas = (vlr) => {
        return (
            <span> {numeral(vlr).format('0,000.0000')} </span>
        );
    };



    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                    width={1400}
                >
                    <div >
                        <div className="titulo">
                            Produtos Vendidos
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Período: </span>
                                <span>{this.props.periodo}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Qtde Vendida 1: </span>
                                <span>{this.renderValor(this.props.qtdeItens1)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Qtde Vendida 2: </span>
                                <span>{this.renderValor(this.props.qtdeItens2)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Valor Total: </span>
                                <span>R$ {this.renderValor(this.props.vlrItens)}</span>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: -20 }}>
                            <Table
                                pagination={false}
                                dataSource={listaRegistros}
                                className="tabela"
                                rowKey={(listaRegistros => listaRegistros.prod_codigo)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="prod_codigo"
                                    dataIndex="prod_codigo"
                                    title="Produto"
                                    width={"8%"}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="prod_descricao"
                                    dataIndex="prod_descricao"
                                    title="Descrição do Produto"
                                    width={"20%"}
                                    align="left"
                                    className="listaCadastro"
                                />


                                <Column
                                    key="qtdeItens"
                                    dataIndex="qtdeItens"
                                    title="Qtde Vendida 1"
                                    render={this.renderValor}
                                    width={"10%"}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="med_descricao1"
                                    dataIndex="med_descricao1"
                                    title="UN 1"
                                    width={"5%"}
                                    align="center"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlrItens"
                                    dataIndex="vlrItens"
                                    title="Valor Unit 1"
                                    render={this.renderValorUN1}
                                    width={"10%"}
                                    align="right"
                                    className="listaCadastro"
                                />




                                <Column
                                    key="qtdeItens2"
                                    dataIndex="qtdeItens2"
                                    title="Qtde Vendida 2"
                                    render={this.renderValor}
                                    width={"10%"}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="med_descricao2"
                                    dataIndex="med_descricao2"
                                    title="UN 2"
                                    width={"5%"}
                                    align="center"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlrItens"
                                    dataIndex="vlrItens"
                                    title="Valor Unit 2"
                                    render={this.renderValorUN2}
                                    width={"10%"}
                                    align="right"
                                    className="listaCadastro"
                                />



                                <Column
                                    key="vlrItens"
                                    dataIndex="vlrItens"
                                    title="Valor Total"
                                    render={this.renderValor}
                                    width={"10%"}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="percVendas"
                                    dataIndex="percVendas"
                                    title="% nas Vendas"
                                    render={this.renderPercVendas}
                                    width={"10%"}
                                    align="right"
                                    className="listaCadastro"
                                />
                            </Table>
                        </Row>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default ProdutosVendidosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/ProdutosVendidosPrintModal.js